const FORM_DATA = {
    quizID: '',
    formID: '',
    inputs: [],
    hasPII: false,
}

const trackQuizInteraction = (quizID, actionDetail, extraData = []) => {
    const properties = {
        interaction_type: "INTERACTION_TYPE_BLOG_QUIZ_INTERACTION",
        interaction_details: {
            location: window.location.href,
            action_detail: actionDetail,
        },
        additional_data: [
            {
                key: "quiz_id",
                value: quizID
            },
            ...(extraData ?? [])
        ]
    }

    segmentGenericEvent('track', properties);

    // Analytics SDK double fire
    fireAnalyticsEvent(Track.WebItemClicked, {
        unique_id: 'blog_quiz',
        label: store.quizId || quizID,
        element_type: 'ELEMENT_TYPE_BUTTON',
        item_value: actionDetail,
        item_details: {
          "blog_quiz": {
            "card": store.card || '',
            "responses": Array.isArray(store.response) ? store.response : [store.response]
          }
        }
    });
}

const trackFormInput = (formData = FORM_DATA, actionDetail) => {
    if (formData == null) {
        return;
    }

    const { quizID, formID, inputs, hasPII } = formData;

    const properties = {
        interaction_type: "INTERACTION_TYPE_BLOG_QUIZ_INTERACTION",
        interaction_details: {
            location: window.location.href,
            action_detail: actionDetail,
        },
        additional_data: [
            {
                key: "quiz_id",
                value: quizID
            },
            {
                key: 'form_id',
                value: formID
            }
        ],
        additional_data_pii: []
    }

    const propertiesKey = hasPII ? 'additional_data_pii' : 'additional_data';

    properties[propertiesKey] = [
        ...properties[propertiesKey],
        ...inputs
    ];

    segmentGenericEvent('track', properties);

    // Analytics SDK double fire
    fireAnalyticsEvent(Track.WebItemClicked, {
        unique_id: 'blog_quiz',
        label: store.quizId || quizID,
        element_type: 'ELEMENT_TYPE_BUTTON',
        item_value: actionDetail,
        item_details: {
          "blog_quiz": {
            "card": store.card || '',
            "responses": Array.isArray(store.response) ? store.response : [store.response]
          }
        }
    });
}

let store = {
    quizId: '',
    formId: '',
    card: '',
    response: [],

    fullName: '',
    email: '',
    isUsCitizen: false,
    isNotMinor: false,

    actionDetail: '',
    location: window.location,
    type: "INTERACTION_TYPE_BLOG_QUIZ_INTERACTION",
};

const updateStore = (contents = store) => {
    if (contents == null) {
        return;
    }

    store = { 
      ...store, 
      ...contents, 
      response: Array.isArray(contents.response) ? contents.response : [contents.response] 
    };
}

/*
    argument :card, String, required: true // cardId
    argument :email, String, required: true // email address
    argument :form_id, String, required: true // formId
    argument :full_name, String, required: true // fullName string from form on card 3
    argument :interaction_action_details, String, required: true // `${trackingKey}_form_submitted`
    argument :interaction_location, String, required: true // window.location.href
    argument :interaction_type, String, required: true  // "INTERACTION_TYPE_BLOG_QUIZ_INTERACTION"
    argument :is_not_minor, Boolean, required: true // boolean from form on card 3
    argument :is_us_citizen, Boolean, required: true // boolean from form on card 3
    argument :quiz_id, String, required: true // quizId
    argument :response, String, required: true // string from copy on card 2
*/

const buildQuery = (store) => {
    return (
        `mutation {
            unauthenticated {
                marketing {
                submit_my_pay_imc_poll(input: {
                        interaction_type: "${store.type}"
                        interaction_location: "${store.location}",
                        interaction_action_details: "${store.actionDetail}",
                        quiz_id: "${store.quizId}",
                        form_id: "${store.formId}",
                        full_name: "${store.fullName}",
                        email: "${store.email}",
                        is_us_citizen: ${store.isUsCitizen},
                        is_not_minor: ${store.isNotMinor},
                        card: "${store.card}",
                        response: "${store.response}"
                    }) {
                    __typename
                    ... on MyPayImcPollResponse {
                    __typename
                    }
                }
                }
            }
        }`
    );
}
